import React from 'react';
import './topic-decision.css';
import { IconButton } from '../icon-button';
import { Paragraph } from '../paragraph';
import PropTypes, { object } from 'prop-types';

const TopicDecision = props => {
    const { options, selectTopic, modalVisible } = props;

    return (
        <div className="topic-decision">
            {options.map(option => {
                return (
                    <div
                        key={option.interest}
                        className="topic-decision__topic"
                    >
                        <div className="topic-decision__topic-heading">
                            <Paragraph
                                colorScheme="dark"
                                withSpacing={false}
                                fontWeight="bold"
                                textAlign="center"
                            >
                                {option.title}
                            </Paragraph>
                        </div>
                        <IconButton
                            onClick={() => selectTopic(option.interest)}
                            iconName={option.interest}
                            size="large"
                            withSpacing={true}
                            isDisabled={modalVisible}
                        />
                        <Paragraph
                            colorScheme="dark"
                            withSpacing={false}
                            withIndent={true}
                            textAlign="center"
                        >
                            {option.notes}
                        </Paragraph>
                    </div>
                );
            })}
        </div>
    );
};

TopicDecision.defaultProps = {
    options: ['local', 'financial', 'global'],
};

TopicDecision.propTypes = {
    options: PropTypes.arrayOf(object),
    selectTopic: PropTypes.func.isRequired,
    modalVisible: PropTypes.bool,
};

export { TopicDecision };
